const initialState = {
  items: [],
};

const cartReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'ADD_TO_CART':
      const existingItemIndex = state.items.findIndex(
        item => item.id === action.payload.id && 
        item.color === action.payload.color && 
        item.size === action.payload.size
      );

      if (existingItemIndex >= 0) {
        // If item exists, update its quantity
        const updatedItems = [...state.items];
        updatedItems[existingItemIndex] = {
          ...updatedItems[existingItemIndex],
          quantity: updatedItems[existingItemIndex].quantity + (action.payload.quantity || 1)
        };
        return {
          ...state,
          items: updatedItems
        };
      } else {
        // If item doesn't exist, add it to the cart with quantity 1
        return {
          ...state,
          items: [...state.items, { 
            ...action.payload, 
            quantity: action.payload.quantity || 1 
          }]
        };
      }

    case 'REMOVE_FROM_CART':
      return {
        ...state,
        items: state.items.filter(item => 
          !(item.id === action.payload.id && 
            item.color === action.payload.color && 
            item.size === action.payload.size)
        )
      };

    case 'UPDATE_QUANTITY':
      return {
        ...state,
        items: state.items.map(item => 
          item.id === action.payload.id && 
          item.color === action.payload.color && 
          item.size === action.payload.size
            ? { ...item, quantity: action.payload.quantity }
            : item
        )
      };

    case 'CLEAR_CART':
      return {
        ...state,
        items: []
      };

    default:
      return state;
  }
};

export default cartReducer; 